<template>
    <div v-if="email" class="d-flex flex-column" style="width: 100%; height: 100%">
        <div class="d-flex align-center py-3">
            <div>

                    <v-text-field
                            v-model="email.title"
                            label="Title"
                    />

            </div>
            <v-spacer></v-spacer>
            <v-btn @click="saveDesign">Save Design</v-btn>
            <v-btn @click="exportHtml" class="ml-3">Export HTML</v-btn>
        </div>
        <div class="flex-row">

            <v-text-field
                    v-model="email.subject"
                    label="Subject"
            />

        </div>

        <EmailEditor :options="options" minHeight="850px" ref="emailEditor" v-on:load="editorLoaded"/>
    </div>
</template>

<script>
    import {EmailEditor} from 'vue-email-editor'
   // import sample from './sample.json'
    import EMAILS_GET from "../graphql/Emails/Get.gql";
    import EMAILS_UPDATE from "../graphql/Emails/Update.gql";

    export default {
        name: 'app',
        components: {
            EmailEditor
        },
        data() {
            return {
                options: {
                    mergeTags: {
                        booker: {
                            name: 'Booker',
                            mergeTags: {
                                first_name: {
                                    name: "First Name",
                                    value: "{{first_name}}",
                                    sample: "John"
                                },
                                last_name: {
                                    name: "Last Name",
                                    value: "{{last_name}}",
                                    sample: "Doe"
                                }
                            }
                        },
                        classes:{
                            name: 'Classes',
                            rules: {
                                repeat: {
                                    name: "Repeat for Each Class",
                                    before: "{{#class}}",
                                    after: "{{/class}}",
                                }
                            },
                            mergeTags:{
                                title: {
                                    name: "Title",
                                    value: "{{title}}",
                                    sample: "Excel 2002"
                                }
                            }
                        }
                    }
                }
            }
        },
        computed: {
            emailContent() {
                return JSON.parse(this.email.content)
            }
        },
        apollo: {
            email: {
                query: EMAILS_GET,
                variables() {return {id:this.$route.params.id}},
                update: data => data.email
            },
        },
        methods: {
            editorLoaded() {
                console.log(this.emailContent)
                if(this.emailContent.schemaVersion) {
                    this.$refs.emailEditor.editor.loadDesign(this.emailContent);
                }
            },
            saveDesign() {
                this.$refs.emailEditor.editor.saveDesign(
                    (design) => {

                        this.$refs.emailEditor.editor.exportHtml(
                            (data) => {

                                this.email.content = design
                                this.email.contentHtml = data
                                this.updateEmail()

                                console.log('saveDesign', design);
                                console.log('exportHtml', data);
                            }
                        )



                    }
                )
            },
            exportHtml() {

            },

            updateEmail() {

                let vars = this.$_.clone(this.email)
                delete vars.__typename
                vars.content = JSON.stringify(vars.content)
                vars.contentHtml = JSON.stringify(vars.contentHtml)


                this.$apollo.mutate({
                    mutation: EMAILS_UPDATE,
                    variables: {input: vars},
                }).then(() => {
                    this.$emit('complete')
                    this.updating = false
                    this.$emit('saved')
                    this.$store.dispatch('notification/addSuccess', 'Email update successful')
                }).catch((error) => {
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            }
        }
    }
</script>